export const diasporaCountries = [
    { code: 'US', label: 'United States', currency: 'USD' },
    { code: 'CA', label: 'Canada', currency: 'CAD' },
    { code: 'GB', label: 'United Kingdom', currency: 'GBP' },
    { code: 'AU', label: 'Australia', currency: 'AUD' },
    { code: 'EU', label: 'France / EU', currency: 'EUR' },
]

export const operatingCountries = [
    { code: 'SL', label: 'Sierra Leone', currency: 'SLE', mode: 'local' },
    { code: 'LR', label: 'Liberia', currency: 'LRD', mode: 'local' },
    { code: 'GN', label: 'Guinea', currency: 'GNF', mode: 'local' },
    { code: 'GM', label: 'Gambia', currency: 'GMD', mode: 'local' },
]

export const businessDirectory = [
    {
        id: 'sl-power-001',
        business_name: 'EDSA Power Services',
        city: 'Freetown',
        country: 'SL',
        category: 'Utilities',
        tags: ['electricity', 'meter', 'postpaid', 'light'],
        status: 'verified',
        payoutCurrency: 'SLE',
        offering: {
            flow: 'bill',
            categoryId: 'electricity',
            accountLabel: 'Meter or Account Number',
            accountPlaceholder: 'Enter meter or service account number',
            accountHint: 'Use the meter number or utility account tied to this bill.',
            amountLabel: 'Electricity Amount',
            amountHint: 'Enter the electricity amount to settle for this service account.',
            descriptor: 'Utilities payment',
        },
    },
    {
        id: 'sl-school-001',
        business_name: 'Freetown Academic College',
        city: 'Freetown',
        country: 'SL',
        category: 'School Fees',
        tags: ['school', 'fees', 'education', 'student'],
        status: 'verified',
        payoutCurrency: 'SLE',
        offering: {
            flow: 'bill',
            categoryId: 'education',
            accountLabel: 'Student or Account Number',
            accountPlaceholder: 'Enter student, invoice, or account number',
            accountHint: 'Use the student ID, bursar reference, or invoice number tied to the fees.',
            amountLabel: 'School Fee Amount',
            amountHint: 'Enter the school fee amount to settle for this student or invoice.',
            descriptor: 'School fees payment',
        },
    },
    {
        id: 'sl-health-001',
        business_name: 'Smile Pharmacy',
        city: 'Bo',
        country: 'SL',
        category: 'Healthcare',
        tags: ['pharmacy', 'medicine', 'health'],
        status: 'verified',
        payoutCurrency: 'SLE',
        offering: {
            flow: 'bill',
            categoryId: 'healthcare',
            accountLabel: 'Patient or Prescription Number',
            accountPlaceholder: 'Enter patient, prescription, or invoice number',
            accountHint: 'Use the patient file, prescription, or billing reference for this healthcare payment.',
            amountLabel: 'Healthcare Amount',
            amountHint: 'Enter the healthcare bill amount that should be cleared.',
            descriptor: 'Healthcare payment',
        },
    },
    {
        id: 'lr-power-001',
        business_name: 'Liberia Energy Service',
        city: 'Monrovia',
        country: 'LR',
        category: 'Utilities',
        tags: ['power', 'electricity', 'bill'],
        status: 'verified',
        payoutCurrency: 'LRD',
        offering: {
            flow: 'bill',
            categoryId: 'electricity',
            accountLabel: 'Meter or Account Number',
            accountPlaceholder: 'Enter meter or service account number',
            accountHint: 'Use the meter number or utility account tied to this bill.',
            amountLabel: 'Electricity Amount',
            amountHint: 'Enter the electricity amount to settle for this service account.',
            descriptor: 'Utilities payment',
        },
    },
    {
        id: 'lr-school-001',
        business_name: 'Monrovia Business Institute',
        city: 'Monrovia',
        country: 'LR',
        category: 'School Fees',
        tags: ['school', 'tuition', 'education'],
        status: 'verified',
        payoutCurrency: 'LRD',
        offering: {
            flow: 'bill',
            categoryId: 'education',
            accountLabel: 'Student or Account Number',
            accountPlaceholder: 'Enter student, invoice, or account number',
            accountHint: 'Use the student ID, bursar reference, or invoice number tied to the fees.',
            amountLabel: 'School Fee Amount',
            amountHint: 'Enter the school fee amount to settle for this student or invoice.',
            descriptor: 'School fees payment',
        },
    },
    {
        id: 'gn-telecom-001',
        business_name: 'Conakry Connect Telecom',
        city: 'Conakry',
        country: 'GN',
        category: 'Telecom',
        tags: ['airtime', 'data', 'telecom', 'mobile'],
        status: 'verified',
        payoutCurrency: 'GNF',
        offering: {
            flow: 'bill',
            categoryId: 'mobileTopUp',
            accountLabel: 'Phone or Service Number',
            accountPlaceholder: 'Enter phone or service account number',
            accountHint: 'Use the phone number or telecom service account that should receive this payment.',
            amountLabel: 'Telecom Amount',
            amountHint: 'Enter the airtime, data, or telecom bill amount to settle.',
            descriptor: 'Telecom payment',
        },
    },
    {
        id: 'gn-market-001',
        business_name: 'Guinee Fresh Market',
        city: 'Conakry',
        country: 'GN',
        category: 'Retail',
        tags: ['market', 'retail', 'groceries'],
        status: 'verified',
        payoutCurrency: 'GNF',
        offering: {
            flow: 'purchase',
            amountLabel: 'Purchase Amount',
            amountHint: 'Enter the amount for this merchant purchase or basket checkout.',
            descriptor: 'Retail payment',
        },
    },
    {
        id: 'gm-school-001',
        business_name: 'Banjul Learning Centre',
        city: 'Banjul',
        country: 'GM',
        category: 'School Fees',
        tags: ['school', 'fees', 'education'],
        status: 'verified',
        payoutCurrency: 'GMD',
        offering: {
            flow: 'bill',
            categoryId: 'education',
            accountLabel: 'Student or Account Number',
            accountPlaceholder: 'Enter student, invoice, or account number',
            accountHint: 'Use the student ID, bursar reference, or invoice number tied to the fees.',
            amountLabel: 'School Fee Amount',
            amountHint: 'Enter the school fee amount to settle for this student or invoice.',
            descriptor: 'School fees payment',
        },
    },
    {
        id: 'gm-insure-001',
        business_name: 'Gambia Family Cover',
        city: 'Serrekunda',
        country: 'GM',
        category: 'Insurance',
        tags: ['insurance', 'medical', 'family'],
        status: 'verified',
        payoutCurrency: 'GMD',
        offering: {
            flow: 'bill',
            categoryId: 'insurance',
            accountLabel: 'Policy or Member Number',
            accountPlaceholder: 'Enter policy, member, or claim number',
            accountHint: 'Use the policy number or member reference linked to this insurance payment.',
            amountLabel: 'Insurance Amount',
            amountHint: 'Enter the premium or insurance bill amount to settle.',
            descriptor: 'Insurance payment',
        },
    },
]

export const findCountry = (code) =>
    operatingCountries.find((country) => country.code === code)

export const getBusinessPaymentProfile = (provider) => {
    if (provider?.offering) return provider.offering

    const category = String(provider?.category || '').toLowerCase()
    const tags = Array.isArray(provider?.tags)
        ? provider.tags.map((tag) => String(tag).toLowerCase())
        : []

    if (category === 'utilities') {
        if (tags.includes('water')) {
            return {
                flow: 'bill',
                categoryId: 'water',
                accountLabel: 'Account Number',
                accountPlaceholder: 'Enter water account number',
                accountHint: 'Use the water account that should receive the settlement.',
                amountLabel: 'Water Amount',
                amountHint: 'Enter the water bill amount to settle.',
                descriptor: 'Water bill payment',
            }
        }

        if (tags.includes('gas')) {
            return {
                flow: 'bill',
                categoryId: 'gas',
                accountLabel: 'Account Number',
                accountPlaceholder: 'Enter gas account number',
                accountHint: 'Use the gas account that should receive the settlement.',
                amountLabel: 'Gas Amount',
                amountHint: 'Enter the gas bill amount to settle.',
                descriptor: 'Gas bill payment',
            }
        }

        return {
            flow: 'bill',
            categoryId: 'electricity',
            accountLabel: 'Meter or Account Number',
            accountPlaceholder: 'Enter meter or service account number',
            accountHint: 'Use the meter number or utility account tied to this bill.',
            amountLabel: 'Electricity Amount',
            amountHint: 'Enter the electricity amount to settle for this service account.',
            descriptor: 'Utilities payment',
        }
    }

    if (category === 'school fees') {
        return {
            flow: 'bill',
            categoryId: 'education',
            accountLabel: 'Student or Account Number',
            accountPlaceholder: 'Enter student, invoice, or account number',
            accountHint: 'Use the student ID, bursar reference, or invoice number tied to the fees.',
            amountLabel: 'School Fee Amount',
            amountHint: 'Enter the school fee amount to settle for this student or invoice.',
            descriptor: 'School fees payment',
        }
    }

    if (category === 'telecom') {
        return {
            flow: 'bill',
            categoryId: 'mobileTopUp',
            accountLabel: 'Phone or Service Number',
            accountPlaceholder: 'Enter phone or service account number',
            accountHint: 'Use the phone number or telecom service account that should receive this payment.',
            amountLabel: 'Telecom Amount',
            amountHint: 'Enter the airtime, data, or telecom bill amount to settle.',
            descriptor: 'Telecom payment',
        }
    }

    if (category === 'healthcare') {
        return {
            flow: 'bill',
            categoryId: 'healthcare',
            accountLabel: 'Patient or Prescription Number',
            accountPlaceholder: 'Enter patient, prescription, or invoice number',
            accountHint: 'Use the patient file, prescription, or billing reference for this healthcare payment.',
            amountLabel: 'Healthcare Amount',
            amountHint: 'Enter the healthcare bill amount that should be cleared.',
            descriptor: 'Healthcare payment',
        }
    }

    if (category === 'insurance') {
        return {
            flow: 'bill',
            categoryId: 'insurance',
            accountLabel: 'Policy or Member Number',
            accountPlaceholder: 'Enter policy, member, or claim number',
            accountHint: 'Use the policy number or member reference linked to this insurance payment.',
            amountLabel: 'Insurance Amount',
            amountHint: 'Enter the premium or insurance bill amount to settle.',
            descriptor: 'Insurance payment',
        }
    }

    return {
        flow: 'purchase',
        amountLabel: 'Payment Amount',
        amountHint: 'Enter the amount for this merchant payment.',
        descriptor: `${provider?.category || 'Merchant'} payment`,
    }
}

export const searchBusinesses = ({ countryCode, query = '' }) => {
    const normalizedQuery = query.trim().toLowerCase()

    return businessDirectory.filter((business) => {
        const matchesCountry = !countryCode || business.country === countryCode
        const matchesQuery =
            normalizedQuery.length === 0 ||
            business.business_name.toLowerCase().includes(normalizedQuery) ||
            business.city.toLowerCase().includes(normalizedQuery) ||
            business.category.toLowerCase().includes(normalizedQuery) ||
            business.tags.some((tag) => tag.toLowerCase().includes(normalizedQuery))

        return matchesCountry && matchesQuery
    })
}
